import React, { useEffect, useRef } from 'react';
import VideoPage from "./pages/video/VideoPage";
import ProcessPage from "./pages/process/ProcessPage";
import SolutionPage from "./pages/solution/SolutionPage";
import HostingPage from "./pages/hosting/HostingPage";
import { useLocation } from 'react-router-dom';
import ServicePage from './pages/service/ServicePage';

import '../custom/swiper.css'; 
import '../custom/slick.css'; 

const Prcs = () => {
    const location = useLocation();
    const swiperRef = useRef(null);

    const number = location.state;
    
    useEffect(() => {
        if(number && number.subMenuId !== undefined){
            const pageNum = parseInt(number.subMenuId);
            console.log('Prcs 페이지 섹션 이동 시도:', pageNum);

            setTimeout(() => {
                if (typeof window.scrollToSection === 'function') {
                    window.scrollToSection(pageNum);
                }
            }, 300);
        }
    }, [number]);

    return (
        <div>
            {/* FullPage.js 메뉴 */}
            <ul id="menu" style={{display: 'none'}}>
                <li data-menuanchor="prcs1"><a href="#prcs1">프로세스1</a></li>
                <li data-menuanchor="prcs2"><a href="#prcs2">프로세스2</a></li>
                <li data-menuanchor="prcs3"><a href="#prcs3">프로세스3</a></li>
                <li data-menuanchor="prcs4"><a href="#prcs4">프로세스4</a></li>
                <li data-menuanchor="prcs5"><a href="#prcs5">푸터</a></li>
            </ul>
            
            {/* FullPage.js 컨테이너 */}
            <div id="fullpage">
                <div className="section" data-anchor="prcs1">
                    <ServicePage />
                </div>
                <div className="section" data-anchor="prcs2">
                    <ProcessPage />
                </div>
                <div className="section" data-anchor="prcs3">
                    <SolutionPage />
                </div>
                <div className="section" data-anchor="prcs4">
                    <HostingPage swiperRef={swiperRef} />
                </div>
            </div>
        </div>
    );
};

export default Prcs;